import { parsePhoneNumberFromString } from "libphonenumber-js";

const formatAddressText = (address) =>
	[
		address?.Line1 ?? address?.address_line_1 ?? address?.line1,
		address?.Line2 ?? address?.address_line_2 ?? address?.line2,
		address?.Line3 ?? address?.address_line_3 ?? address?.line3,
		address?.City ?? address?.address_city ?? address?.city,
		address?.PostalCode ?? address?.address_postcode ?? address?.postcode,
	]
		.filter(Boolean)
		.join(", ");

export const normalizeVerifiedAddress = (address) => {
	if (!address || typeof address !== "object") return null;

	const normalized = {
		...address,
		Line1: address.Line1 ?? address.address_line_1 ?? address.line1 ?? "",
		Line2: address.Line2 ?? address.address_line_2 ?? address.line2 ?? "",
		Line3: address.Line3 ?? address.address_line_3 ?? address.line3 ?? "",
		City: address.City ?? address.address_city ?? address.city ?? "",
		PostalCode:
			address.PostalCode ?? address.address_postcode ?? address.postcode ?? "",
		CountryName: address.CountryName ?? address.country ?? "United Kingdom",
	};
	const text = address.Text ?? formatAddressText(normalized);

	if (!text && !normalized.Line1 && !normalized.PostalCode) return null;

	return {
		...normalized,
		Text: text,
	};
};

export const normalizeVerifiedAddresses = (addresses) => {
	const list = Array.isArray(addresses)
		? addresses
		: addresses && typeof addresses === "object"
			? [addresses]
			: [];

	return list.map(normalizeVerifiedAddress).filter(Boolean);
};

export const normalizeVerifiedTelephone = (telephone) => {
	if (!telephone) return "";

	const value = String(telephone).trim();
	if (!value) return "";

	const phoneNumber = parsePhoneNumberFromString(value, "GB");
	return phoneNumber?.isValid() ? phoneNumber.number : "";
};

export const mapVerifiedClientDetails = (response) => {
	if (!response || typeof response !== "object") {
		return {
			title: "",
			firstName: "",
			surname: "",
			middleName: "",
			previousName: "",
			dob: "",
			mobile: "",
			email: "",
			confirmEmail: "",
			currentAddress: null,
			currentPostcode: "",
			previousAddress: [],
			signatureToken: null,
		};
	}

	const verifiedCurrentAddress = normalizeVerifiedAddress(response.address);
	const verifiedPreviousAddresses = normalizeVerifiedAddresses(
		response.previous_address,
	);

	return {
		title: response.title ?? "",
		firstName: response.first_name ?? "",
		surname: response.last_name ?? "",
		middleName: response.middle_name ?? "",
		previousName: response.previousName ?? response.previous_name ?? "",
		dob: response.date_of_birth ?? "",
		mobile: normalizeVerifiedTelephone(response.telephone),
		email: response.email ?? "",
		confirmEmail: response.email ?? "",
		currentAddress: verifiedCurrentAddress,
		currentPostcode: verifiedCurrentAddress?.PostalCode ?? "",
		previousAddress: verifiedPreviousAddresses,
		signatureToken: response.signature_token ?? null,
	};
};
